export default __webpack_public_path__ + "assets/front/scss/editorial.c82582d54cf5cf0fd4bf92af0d1fd635.css";